var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 24.5C6 19.5935 7.9491 14.8879 11.4185 11.4185C14.8879 7.9491 19.5935 6 24.5 6C29.4065 6 34.1121 7.9491 37.5815 11.4185C41.0509 14.8879 43 19.5935 43 24.5V41.1675C43 42.0375 42.9872 42.1802 42.9661 42.2591C42.9207 42.4287 42.8315 42.5832 42.7074 42.7073L43.768 43.768L42.7073 42.7074C42.5832 42.8315 42.4287 42.9207 42.2591 42.9661C42.1802 42.9872 42.0375 43 41.1675 43H24.5C19.5935 43 14.8879 41.0509 11.4185 37.5815C7.9491 34.1121 6 29.4065 6 24.5Z",
    fill: "#94A3B8",
    fillOpacity: 0.2,
    stroke: "#94A3B8",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 20.75H33.25M15.75 28.25H28.25",
    stroke: "#94A3B8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon01.17acaa88ca63119791486ca85ee1caeb.svg";
export { ForwardRef as ReactComponent };